function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export default (function (_ref) {
  var _menu;
  var colors = _ref.colors,
    mediaQueries = _ref.mediaQueries;
  return {
    menu: (_menu = {
      display: 'none',
      position: 'absolute',
      right: '5px',
      top: '4px',
      color: colors.secondary,
      cursor: 'pointer'
    }, _defineProperty(_menu, mediaQueries.breakpointTablet, {
      display: 'block'
    }), _defineProperty(_menu, '&.close', {
      top: '12px',
      right: '12px',
      width: '28px',
      height: '28px',
      fill: colors.gray
    }), _defineProperty(_menu, '&.button', _defineProperty({
      display: 'none',
      fontSize: '12px',
      fontWeight: 500,
      background: 'transparent',
      border: "1px solid ".concat(colors.grayLight),
      borderRadius: '4px',
      position: 'absolute',
      right: '10px',
      top: '10px',
      height: '30px',
      color: colors.secondary
    }, mediaQueries.breakpointTablet, {
      display: 'block'
    })), _defineProperty(_menu, '&.burger', {
      width: '40px',
      height: '40px',
      fill: colors.gray
    }), _menu)
  };
});